import { render, staticRenderFns } from "./MajorMaintenanceResolution.vue?vue&type=template&id=64208f9e"
import script from "./MajorMaintenanceResolution.vue?vue&type=script&lang=js"
export * from "./MajorMaintenanceResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports